import { Box } from "@chakra-ui/react";
import cs from "classnames";
import type React from "react";
import type { FC } from "react";

const baseClasses = [
  "flex",
  "flex-col",
  "items-center",
  "justify-center",
  "w-64",
  "h-48",
  "border",
  "border-solid",
  "border-gray-700",
  "border-r-0",
  "last:border-r",
  "last:rounded-r-lg",
  "first:rounded-l-lg",
];

interface SimpleBoxProps {
  minWidth?: string;
  minHeight?: string;
}

export const SimpleBox: FC<React.PropsWithChildren<SimpleBoxProps>> = ({
  minWidth,
  minHeight,
  children,
}) => (
  <Box className={cs(baseClasses)} style={{ minWidth, minHeight }}>
    {children}
  </Box>
);
